import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
    cardItemContainer: {
        display: "flex",
        alignItems: "center",
        "@media (max-width: 1200px)": {
            flexDirection: "column",
        },
        "@media (max-width: 600px)": {
            padding: 0
        },
        // Variations
        "&.comment-card": {
            justifyContent: "space-between",
            alignItems: "start",
            "&.left": {
                "& .cardTexHelper": {
                    "&:before": {
                        left: -29
                    }
                },
                "& .cardImgHelper": {
                    marginRight: 54
                }
            },
            "&.right": {
                "& .cardTexHelper": {
                    "&:before": {
                        right: -29,
                        transform: "rotate(-90deg)"
                    }
                },
                "& .cardImgHelper": {
                    marginLeft: 54,
                    order: 2
                }
            },
            "& .cardTexHelper": {
                width: "100%",
                background: "#FFFFFF",
                borderRadius: 16,
                padding: 48,
                position: "relative",
                margin: 0,
                "& h2": {
                    marginBottom: 0
                },
                "& p": {
                    marginTop: 16,
                    fontWeight: 500,
                    "& + p": {
                        marginTop: 24
                    }
                },
                "&:before": {
                    content: "''",
                    position: "absolute",
                    top: 56,
                    border: "15px solid transparent",
                    borderTop: "15px solid #fff",
                    borderRight: "15px solid #fff",
                    "@media (max-width: 1200px)": {
                        top: 40
                    },
                    "@media (max-width: 600px)": {
                        border: "12px solid transparent",
                        borderTop: "12px solid #fff",
                        borderRight: "12px solid #fff",
                        top: -24,
                        left: "unset !important",
                        right: "unset !important",
                        transform: "rotate(-180deg) !important"
                    }
                },
                "@media (max-width: 600px)": {
                    padding: 24
                }
            },
            "& .cardImgHelper": {
                width: 120,
                flexShrink: 0,
                "& img": {
                    width: "inherit",
                    height: "auto",
                    borderRadius: "50%"
                },
                "@media (max-width: 1200px)": {
                    width: 80
                },
                "@media (max-width: 600px)": {
                    width: 64,
                    order: "-1 !important",
                    marginRight: "0 !important",
                    marginLeft: "0 !important",
                    marginBottom: 40
                }
            },
            "@media (max-width: 1200px)": {
                flexDirection: "row"
            },
            "@media (max-width: 600px)": {
                flexDirection: "column"
            }
        },
        "&.cloud-platform-events-card": {
            marginTop: 64,
            "& .cardTexHelper": {
                paddingRight: 32,
                "& $cardTitle": {
                    textTransform: "uppercase",
                    fontSize: 20,
                    fontWeight: 700,
                    color: "#6049EB",
                    marginBottom: 4
                },
                "& a.order-button": {
                    minWidth: 288
                }
            },
            "& .cardImgHelper": {
                padding: 0,
                fontSize: 0,
                width: "49.02%",
                "& iframe": {
                    width: "100% !important"
                }
            }
        },
        "&.amount-container": {
            justifyContent: "space-between",
            "& .h1": {
                marginBottom: 64,
                "&.blue": {
                    marginBottom: 8,
                    color: "#6049EB",
                }
            },
            "& > div:first-child": {
                width: "62%",
                "& .main-amount-container": {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between"
                }
            },
            "& > div:last-child": {
                width: "32%",
            },
            "@media (max-width: 1200px)": {
                padding: 0,
                "& .h1": {
                    marginBottom: 32,
                },
                "& .h1, .h4": {
                    textAlign: "center",
                },
                "& > div:first-child": {
                    width: "100%",
                    "& .main-amount-container": {
                        justifyContent: "space-around !important",
                        gap: 30,
                        flexWrap: "wrap",
                    }
                },
                "& > div:last-child": {
                    width: "60%",
                },
            }
        },
        "&.our-choice-card": {
            "& > div:first-child": {
                padding: "0 48px 0 68px",
            },
            "@media (max-width: 1200px)": {
                "& > div:first-child": {
                    padding: 0,
                },
            }
        }
    },
    cardTextContainer: {
        width: "50%",
        "&[data-position='left']": {
            paddingLeft: 48,
            "@media (max-width: 1200px)": {
                paddingLeft: 0,
                paddingRight: 0
            }
        },
        "&[data-position='right']": {
            paddingRight: 48,
            "@media (max-width: 1200px)": {
                paddingRight: 0,
                paddingLeft: 0
            }
        },
        "& p + p": {
            marginTop: 48
        },
        "@media (max-width: 1200px)": {
            width: "100%",
            padding: 0,
            marginTop: 64
        },
        "@media (max-width: 600px)": {
            marginTop: 40,
            "& p + p": {
                marginTop: 24
            },
        },
    },
    cardTitle: {
        marginBottom: 24,
        whiteSpace: "pre-line",
        "@media (max-width: 1200px)": {
            marginBottom: 24,
            whiteSpace: "unset"
        },
        "@media (max-width: 600px)": {
            marginBottom: 16
        },
    },
    cardSubtitle: {
        color: "#6049EB",
        fontWeight: "600 !important",
        marginBottom: 10
    },
    cardBody: {
        "& br": {
            "@media (max-width: 1200px)": {
                display: "none"
            }
        },
        "& .marked-list": {
            "& li": {
                listStyle: "none",
                position: "relative",
                paddingLeft: 26,
                fontSize: 20,
                textAlign: "start",
                marginTop: 24,
                "@media (max-width: 600px)": {
                    paddingLeft: 22,
                    textAlign: "left",
                    fontSize: 16,
                },
                "&:before": {
                    content: "''",
                    width: 10,
                    height: 10,
                    display: "inline-block",
                    position: "absolute",
                    left: 0,
                    top: 11,
                    backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='5' cy='5' r='5' fill='%236049EB'/%3E%3C/svg%3E%0A\")",
                    "@media (max-width: 600px)": {
                        top: 8,
                        width: 8,
                        height: 8,
                        backgroundSize: "cover"
                    }
                },
                "& + li": {
                    marginTop: 24
                }
            },
            "&.popular-options": {
                "& li": {
                    marginTop: 12
                }
            }
        },
        "& .create-list": {
            marginLeft: 28
        },
        "& .marked-list-black": {
            "& li": {
                listStyle: "none",
                position: "relative",
                paddingLeft: 32,
                "&:before": {
                    content: "''",
                    width: 4,
                    height: 4,
                    backgroundColor: "#2D2442",
                    display: "block",
                    position: "absolute",
                    left: 13,
                    top: 15,
                    borderRadius: "50%",
                    "@media (max-width: 600px)": {
                        top: 12
                    }
                }
            }
        },
        "& .boldText": {
            fontWeight: "600",
        },
        "& .blueText": {
            fontSize: 18,
            color: "#6049EB",
            marginTop: 40,
            "@media (max-width: 600px)": {
                fontSize: 16,
                textAlign: "center",
            },
        },
        "& .order-button": {
            marginTop: 40,
        },
        "& .cloud-platform-button": {
            marginTop: 24,
            minWidth: 232
        },
        "@media (max-width: 1200px)": {
            maxWidth: "100%",
            marginLeft: "auto",
            marginRight: "auto"
        },
        "@media (max-width: 600px)": {
            "& a": {
                width: "100%",
            }
        }
    },
    cardImgContainer: {
        width: "50%",
        fontSize: 0,
        flexShrink: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0 48px",
        "& img": {
            width: "100%"
        },
        "&[data-position='left']": {
            order: -1
        },
        "@media (max-width: 1200px)": {
            width: "100%",
            padding: 0,
            order: -1
        },
        "@media (max-width: 600px)": {
            order: -1
        },
        "& iframe": {
            borderRadius: 8,
            "@media (max-width: 768px)": {
                width: "100%",
            }
        }
    }
});
